/**
 * Centralized Google Analytics 4 event tracking.
 * All custom events flow through here so we have one source of truth
 * for naming, parameters, and safety (no crash if gtag is blocked by adblock).
 */

const gtag = (...args) => {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  try {
    window.gtag(...args);
  } catch {
    /* gtag blocked by adblock — fail silently */
  }
};

/**
 * Track a custom event. Use the helpers below for typed events.
 * @param {string} name - GA4 event name (snake_case)
 * @param {object} params - Custom parameters (string/number values only)
 */
export const track = (name, params = {}) => {
  gtag("event", name, params);
};

// =============== Funnel events ===============

/** Fired when a user clicks the primary register CTA from the landing/blog/etc. */
export const trackRegisterClick = (source = "unknown") =>
  track("cta_click_register", { cta_source: source });

/** Fired when a user clicks one of the install badges (Android/iPhone) or generic install link. */
export const trackInstallClick = (platform, source = "unknown") =>
  track("cta_click_install", { install_platform: platform, cta_source: source });

/** Fired the first time a logged-in user sends a chat message to B in their lifetime. */
export const trackFirstChatMessage = () => track("chat_first_message", {});

/** Fired when Stripe checkout session is initiated (subscription or bonus pack). */
export const trackSubscriptionStarted = (planId, planType = "subscription") =>
  track("subscription_started", { plan_id: planId, plan_type: planType });

/** Fired when a user clicks the LinkedIn/Instagram links. */
export const trackSocialFollowClick = (network, source = "unknown") =>
  track("social_follow_click", { social_network: network, cta_source: source });
